// tslint:disable: max-line-length
import { Component, OnInit } from '@angular/core';
import { BuildingBlock } from '../building-block.types';
import { AutofillControlBaseComponent } from '../../control-base/autofill-control-base.component';
import { PrefillRequest } from './app-prefill.type';

export type StatusFlag = 'in-progress' | 'is-error';

@BuildingBlock('app-prefill')
@Component({
  selector: 'ecp-app-prefill',
  templateUrl: './app-prefill.component.html'
})
export class AppPrefillComponent extends AutofillControlBaseComponent implements OnInit {
  private status: string;

  /** To get option for pre fill  */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public preFillOptions: any = [
    { label: 'Lender 999', value: '999' },
    { label: 'Complex Result (Simulated)', value: 'COMPLEXRESULT' },
    { label: 'Simple Result (Simulated)', value: 'SIMPLERESULT' }
  ];

  private orderCompleteReq = {
    orderId: '',
    retryRequest: true,
    maxRetryTime: 60 // In seconds
  };
  public selectedPrefillType: string;
  public get callStatusMsg(): string {
    return this.status;
  }

  public get prefillRequest(): PrefillRequest {
    return {
      firstName: 'William',
      lastName: 'Buzzerd',
      ssn: '666540270',
      prefillType: this.selectedPrefillType
    };
  }

  /** busy flag */
  public get isLoading(): boolean {
    return this.statefulService.wrap(`mem:${this.coAppSwitch}app-prefill-is-loading`).valueString === 'true';
  }
  public set isLoading(value: boolean) {
    this.statefulService.wrap(`mem:${this.coAppSwitch}app-prefill-is-loading`).value = value;
  }
  public ngOnInit(): void {
    this.autofillType = 'app-prefill';
    this.isInProgress = this.isLoading;
    this.selectedPrefillType = this.statefulService.wrap('api:prefillType').valueString;
  }

  public onChangePrefillType(): void {
    this.statefulService.wrap('api:prefillType').value = this.selectedPrefillType;
  }

  public appAutofill(): void {
    this.isLoading = true;
    this.isInProgress = true;
    this.isError = false;
    this.status = '';

    this.applicationApiService.appPrefill(
      this.prefillRequest,
      (res) => {
        this.orderCompleteReq.orderId = res.data;
        this.getCompleteResponse();
        this.status = 'Order created successfully!';
      },
      (error) => {
        this.handleError(error);
      }
    );
  }

  /** This function is used for prefill card event loading and get back the response from api prefill.  */
  private getCompleteResponse() {
    this.applicationApiService.getPrefillResponse(
      this.orderCompleteReq,
      (response) => {
        if (response?.isSuccess) {
          this.isLoading = false;
          this.isInProgress = false;
          this.status = 'Successfully prefilled app';

          this.field.data.value = JSON.stringify(response.data);
          /* To update prefill data, Temporaryly binding update method to click event */
          this.onClick(new Event('click'));
        }
      },
      (error) => {
        this.handleError(error);
      }
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private handleError(message: string): void {
    this.isLoading = false;
    this.isError = true;
    this.isInProgress = false;
    this.status = 'An error occured prefilling app';
  }
}
